import React, { createContext, useContext, useState } from 'react'

export interface TourStateProps {
  runDesktopTour: boolean
  runMobileTour: boolean
  desktopTourStepIndex: number
}

interface ContextProps {
  tourState: TourStateProps
  updateTourState: (args: Partial<TourStateProps>) => void
}

const TourContext = createContext<null | ContextProps>(null)

export const useFirstRequestTourContext = () => useContext(TourContext)

const FirstRequestTourProvider = ({ children }) => {
  const [tourState, setTourState] = useState<TourStateProps>({
    desktopTourStepIndex: 0,
    runDesktopTour: false,
    runMobileTour: false
  })

  const updateTourState = updates => setTourState({ ...tourState, ...updates })

  const value = {
    tourState,
    updateTourState
  }

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>
}

export default FirstRequestTourProvider
